<!-- Details.vue -->
<template>
  <div class="show-iframe" style="margin-top: 20px; margin-bottom: 60px">
    <div
      class="mb-body"
      v-if="detailInfo.plateid_top && detailInfo.plate_top"
      v-html="detailInfo.plate_top.storeplate_content"
    ></div>
    <div v-if="!mbBody.length">
      <div class="mb-body" v-if="detailInfo.goods_body">
        <div v-html="detailInfo.goods_body"></div>
      </div>
      <div class="list-empty" v-else>
        <div class="iconfont empty-icon">&#xe636;</div>
        <p>{{ $t("noMore") }}</p>
      </div>
    </div>
    <div class="mb-body" v-else>
      <div v-for="(item, index) in mbBody" :key="index">
        <p v-if="item.type == 'text'">{{ item.value }}</p>
        <!-- <img v-else :src="item.value"> -->
        <img v-else :src="item" />
      </div>
    </div>
    <div
      class="mb-body"
      v-if="detailInfo.plateid_bottom && detailInfo.plate_bottom"
      v-html="detailInfo.plate_bottom.storeplate_content"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    getUrl: function () {
      return this.url;
    },
  },
  props: ["mbBody", "detailInfo"],
  methods: {},
};
</script>

<style lang="scss">
.list-empty {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  .empty-icon {
    font-size: 3rem;
    padding: 1rem 0;
    color: #999;
  }

  p {
    color: #7c7f88;
    font-size: $subFontSize;
    padding: 0;
    margin: 0;
    font-weight: normal;
  }
}

.mb-body {
  font-size: $subFontSize;

  img {
    max-width: 100% !important;
  }

  p {
    line-height: 1.5;
    padding: 0 $pageSpace;
  }
}
</style>
